import React from "react";

const timelineSteps = [
  {
    status: "Pending",
    title: "Order Placed",
    description: "Order submitted by customer",
  },
  {
    status: "Accepted",
    title: "Order Confirmed",
    description: "Order verified by system",
  },
  // { title: "Order Packed", description: "Items picked and packed" },
  {
    status: "Shipped",
    title: "Shipped",
    description: "Package sent to courier",
  },
  {
    status: "Completed",
    title: "Delivered",
    description: "Order delivered to customer",
  },
];

const Timeline = ({ currentStatus }) => {
  const currentIdx = timelineSteps.findIndex(
    (step) => step.status === currentStatus
  );

  return (
    <div className="w-full flex flex-col md:flex-row md:justify-center py-6 px-5 md:mb-[75px]">
      {timelineSteps.map((step, idx) => {
        const isCompleted = idx < currentIdx;
        const isCurrent = idx === currentIdx;

        const circleStyle = isCompleted
          ? "bg-green-500"
          : isCurrent
          ? "bg-blue-600"
          : "bg-gray-300";
        const textStyle = isCompleted
          ? "text-white"
          : isCurrent
          ? "text-white font-bold"
          : "text-gray-800";

        return (
          <div
            key={step.title}
            className="flex  flex-row md:flex-col items-center md:items-stretch relative"
            style={{ minWidth: 0 }}
          >
            {/* Left: circle and MOBILE line vertically aligned */}
            <div className="flex flex-col md:flex-row ">
              {/* Step Number (circle) */}
              <div className="flex items-center md:flex-col relative">
                <div
                  className={`flex items-center justify-center h-8 w-8 rounded-full z-10 ${circleStyle} ${textStyle} shrink-0`}
                >
                  {isCompleted ? (
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    idx + 1
                  )}
                </div>
                {/* Content */}
                <div
                  className="ml-3 md:ml-0 md:m-0 min-w-[92px] max-w-[130px] md:absolute top-[110%] left-1/2 md:translate-x-[-50%] md:text-center"
                  // style={{ transform: "translateX(-50%)" }}
                >
                  <div
                    className={`${
                      isCurrent
                        ? "font-bold text-blue-700"
                        : isCompleted
                        ? "text-green-700"
                        : "text-gray-800"
                    } text-sm`}
                  >
                    {step.title}
                  </div>
                  <div className="text-gray-500 text-xs hidden md:block">
                    {step.description}
                  </div>
                </div>
              </div>
              {/* Vertical connector for mobile (align center of circle) */}
              {idx !== timelineSteps.length - 1 && (
                <div className="flex-1 flex w-8 md:w-[10vw]  justify-center md:items-center">
                  <div className="w-0.5 h-8 md:w-full md:h-0.5 bg-blue-300"></div>
                </div>
              )}
            </div>
            {/* Horizontal connector for desktop (align center of circle) */}
            {/* {idx !== timelineSteps.length - 1 && (
              <div className="hidden md:flex mt-3 flex-col items-center">
                <div className="h-0.5 w-16 bg-blue-300"></div>
              </div>
            )} */}
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
